import { render } from "./HeroiconsOutlineUser.vue?vue&type=template&id=6453ff29"
const script = {}

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineUser.vue"]])

export default __exports__